import Flag from "./flag.jpg";
import EICLogo from "./eic_logo.jpg";
import RightTopMotto from "./right_top_motto.png";
import EmblemOfEthiopia from "./Emblem_of_Ethiopia.png";
import ButtomReport from "./buttom_report.png";
import { IpdcTransparentLogo } from "../login";

export { Flag, EICLogo, RightTopMotto, EmblemOfEthiopia,ButtomReport , IpdcTransparentLogo};